const buttonClass = "b1bqcm8n";
export default buttonClass;

require("./Button.styles.linaria.module.css");